import { Grid } from '@chakra-ui/react';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from '../../stores/userStore';
import { CategoryCard } from './categoryCard';
import { calculateMaxFilter } from '../../utils/filterUtils';
import { Category } from '../../../api/src/types/types';

export interface CategoryGridProps { }

export const CategoryGrid = (props: CategoryGridProps) => {
  const { user } = useUserStore();
  const navigate = useNavigate();

  // Categorie disponibili dalla sessione utente
  const baseCategories = user.categories || [];

  // Verifica se esiste la categoria "Buoni" (595316) e aggiungi le sottocategorie virtuali
  const categories = useMemo(() => {
    const hasBuoniCategory = baseCategories.some((cat: Category) => cat.key === '595316');
    
    if (!hasBuoniCategory) {
      return baseCategories;
    }

    // Aggiungi le categorie virtuali per Buoni alimentari e Buoni carburante
    const virtualCategories: Category[] = [
      { key: '595316-BAWL', value: 'Buoni alimentari' },
      { key: '595316-BCWL', value: 'Buoni carburante' }
    ];

    return [...baseCategories, ...virtualCategories];
  }, [baseCategories]);

  // Navigazione al catalogo con filtro categoria pre-applicato
  const handleCategoryClick = useCallback((categoryKey: string) => {
    let actualCategoryKey = categoryKey;
    let keyword = '';

    // Gestisci le categorie virtuali con keyword speciali
    if (categoryKey.includes('-BAWL')) {
      actualCategoryKey = '595316';
      keyword = 'BAWL';
    } else if (categoryKey.includes('-BCWL')) {
      actualCategoryKey = '595316';
      keyword = 'BCWL';
    }

    const searchParams = new URLSearchParams({
      category: actualCategoryKey,
      filters: 'true',
      pmin: '0',
      pmax: calculateMaxFilter(user.collections).toString(),
      keywords: keyword
    });

    navigate(`/catalog?${searchParams.toString()}`);
  }, [navigate, user.collections]);

  // Non mostrare griglia se non ci sono categorie o ce n'è solo una
  if (categories.length <= 1) {
    // Se c'è una sola categoria, naviga direttamente al catalogo
    if (categories.length === 1) {
      handleCategoryClick(categories[0].key);
      return null;
    }
    return null;
  }

  return (
    <Grid
      templateColumns={{ 
        base: 'repeat(1, 1fr)', 
        md: 'repeat(2, 1fr)', 
        lg: 'repeat(3, 1fr)',
        xl: 'repeat(4, 1fr)' 
      }}
      gap={{ base: '1.5rem', lg: '2rem' }}
      mx="auto"
      maxW={{ base: '100%', lg: '1200px', xl: '1400px' }}
      p={{ base: '1rem', lg: '2rem' }}
      justifyItems="center"
    >
      {categories.map((category) => (
        <CategoryCard
          key={category.key}
          category={category}
          onClick={() => handleCategoryClick(category.key)}
        />
      ))}
    </Grid>
  );
};
